import { useState } from "react";
import { motion } from "framer-motion";
import { RARITY } from "@/lib/format";
import GP from "@/components/GP";
import ProductModal from "@/components/ProductModal";

function spot(e) {
  const b = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - b.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - b.top}px`);
}

export default function NameWall({ items }) {
  const [sel, setSel] = useState(null);
  const names = items.slice(0, 19);
  if (!names.length) return null;

  return (
    <section className="relative max-w-[1700px] mx-auto px-5 md:px-10 py-24" data-testid="name-wall-section">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
        <div>
          <div className="overline-label mb-4">// the wall of names</div>
          <h2 className="font-display text-5xl md:text-8xl leading-[0.9]">Targets <span className="hot-text">acquired</span></h2>
        </div>
        <p className="text-[#999] max-w-sm text-sm">Every name here is one-of-one. Hover to light it up. Click to lock it in before someone else does.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 auto-rows-[150px] md:auto-rows-[170px] border-l border-t border-white/10">
        {names.map((p, i) => {
          const r = RARITY[p.rarity] || RARITY.common;
          const big = i === 0;
          const len = p.title.length;
          const size = big ? "text-5xl md:text-7xl" : len <= 6 ? "text-4xl md:text-5xl" : len <= 10 ? "text-3xl md:text-4xl" : "text-2xl md:text-3xl";
          return (
            <motion.button key={p.id} type="button" onMouseMove={spot} onClick={() => setSel(p)}
              initial={{ opacity: 0, scale: 0.92 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true, margin: "-30px" }} transition={{ duration: 0.4, delay: (i % 6) * 0.05 }}
              data-testid={`name-wall-tile-${p.id}`}
              className={`wall-tile group relative text-left overflow-hidden border-r border-b border-white/10 p-5 flex flex-col justify-between ${big ? "col-span-2 row-span-2" : ""}`}
              style={{ "--glow": r.glow, "--rc": r.color }}>
              <span className="relative z-10 text-[10px] font-bold tracking-[0.22em] uppercase" style={{ color: r.color }}>{r.label}</span>
              <span className={`relative z-10 font-display leading-none chrome-text-sm break-all transition-transform duration-300 group-hover:scale-105 group-hover:animate-flicker origin-left ${size}`}
                style={{ filter: `drop-shadow(0 3px 0 #5a0018) drop-shadow(0 0 14px ${r.glow})` }}>{p.title}</span>
              <span className="relative z-10 flex items-center justify-between">
                <GP m={p.price} obo={p.obo} coin size={20} className="text-xl" />
                <span className="text-[10px] tracking-[0.2em] uppercase text-[#777] opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-200">{p.obo ? "Make offer" : "Lock in"}</span>
              </span>
            </motion.button>
          );
        })}
      </div>
      {sel && <ProductModal p={sel} onClose={() => setSel(null)} />}
    </section>
  );
}
